import React from "react";

// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
// LoadingSpinner — the app's standard loading visual, as a reusable,
// container-positioned component.
//
// GlobalLoadingIndicator (the main scheduler's loading overlay) is wired to
// the app's TanStack fetch flags and renders fixed/full-screen. This component
// reproduces the SAME look — the 48px spinning ring + "Loading data..." in a
// dark rounded card — but centers within its parent so it can be dropped into
// modals/panels (e.g. Compass) that do their own fetching. Keep the spinner
// styling in step with GlobalLoadingIndicator so the two read as identical.
// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

export const LoadingSpinner = ({ label = "Loading data...", fillHeight = true }) => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      height: fillHeight ? "100%" : undefined,
      padding: "24px",
    }}
  >
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "12px",
        padding: "24px 32px",
        backgroundColor: "rgba(0, 0, 0, 0.75)",
        borderRadius: "12px",
        boxShadow: "0 8px 32px rgba(0, 0, 0, 0.3)",
      }}
    >
      <div
        style={{
          width: "48px",
          height: "48px",
          border: "4px solid rgba(255, 255, 255, 0.2)",
          borderTop: "4px solid #ffffff",
          borderRadius: "50%",
          animation: "spin 1s linear infinite",
        }}
      />
      {label ? (
        <div
          style={{
            color: "#ffffff",
            fontSize: "14px",
            fontWeight: "600",
            letterSpacing: "0.5px",
            textAlign: "center",
          }}
        >
          {label}
        </div>
      ) : null}
      <style>
        {`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}
      </style>
    </div>
  </div>
);

export default LoadingSpinner;
